<template>
  <span class="computed">{{
    props.seconds === null ? 'null' : formatDuration(props.seconds)
  }}</span>
</template>

<script setup lang="ts">
import { formatDuration } from '@/utils/date.ts'

const props = defineProps<{
  seconds: number | null
}>()
</script>

<style scoped lang="scss">
.computed {
  // a badge-like style
  background: var(--color-background-mute);
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  padding: 0.3rem 0.6rem;
  color: var(--color-text-muted);
  font-size: 0.75rem;
}
</style>
